import { combineReducers } from "redux";
import previewReducer from "./previewReducer";
import projectReducer from "./projectReducer";

const reducers = combineReducers({
    project: projectReducer,
    preview: previewReducer
})

export default reducers;